import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { UpdateOrderDeliveryCdek } from './UpdateOrderDeliveryCdek'
import { UpdateOrderDeliveryCdekCourier } from './UpdateOrderDeliveryCdekCourier'
import { UpdateOrderDeliveryPickup } from './UpdateOrderDeliveryPickup'
import { UpdateOrderDeliveryManual } from './UpdateOrderDeliveryManual'
import { UpdateOrderDeliveryPochta } from './UpdateOrderDeliveryPochta'
import { UpdateOrderDeliveryPochtaCourier } from './UpdateOrderDeliveryPochtaCourier'
import { UpdateOrderItem } from './UpdateOrderItem'
import { OrderAttributionWrite } from './OrderAttributionWrite'
/**
* Class UpdateOrder
*  Данные для создания/изменения заказа
*/
export class UpdateOrder extends ActiveModel {

/**
  * delivery
  * Способ доставки (полиморфно по `kind`, id из `GET orders/config`).<br>  */
  @ActiveField({
  setter(model: UpdateOrder, prop: string, value: UpdateOrderDeliveryCdek | UpdateOrderDeliveryCdekCourier | UpdateOrderDeliveryPickup | UpdateOrderDeliveryManual | UpdateOrderDeliveryPochta | UpdateOrderDeliveryPochtaCourier, receiver?: UpdateOrder ) {
      let concreteValue = value
      switch (value.kind) {
          case 'Cdek': {
            concreteValue = UpdateOrderDeliveryCdek.create(value)
            break;
          }
          case 'CdekCourier': {
            concreteValue = UpdateOrderDeliveryCdekCourier.create(value)
            break;
          }
          case 'Pickup': {
            concreteValue = UpdateOrderDeliveryPickup.create(value)
            break;
          }
          case 'Manual': {
            concreteValue = UpdateOrderDeliveryManual.create(value)
            break;
          }
          case 'Pochta': {
            concreteValue = UpdateOrderDeliveryPochta.create(value)
            break;
          }
          case 'PochtaCourier': {
            concreteValue = UpdateOrderDeliveryPochtaCourier.create(value)
            break;
          }
      }

      return Reflect.set(
        model,
        prop,
        concreteValue,
        receiver
      )
    }
  })
  delivery: UpdateOrderDeliveryCdek | UpdateOrderDeliveryCdekCourier | UpdateOrderDeliveryPickup | UpdateOrderDeliveryManual | UpdateOrderDeliveryPochta | UpdateOrderDeliveryPochtaCourier | null | undefined = undefined


/**
  * @property products
  * Продукты в заказе<br>  */
  @ActiveField({
    factory: [UpdateOrderItem, () => []]
  })
  products: Array<UpdateOrderItem> = []


/**
  * email
  * <inheritdoc cref="P:Domain.Entities.Orders.Order.UserEmail" />
  */
  @ActiveField()
  email?: string


/**
  * phone
  * <inheritdoc cref="P:Domain.Entities.Orders.Order.UserPhone" /><br><br><br>            Если пользователь НЕ аноним, но в профиле нет номера телефона, то обязано быть заполнено<br>
  */
  @ActiveField()
  phone?: string


/**
  * fio
  * ФИО контактного лица (для случаев, когда пользователь аноним или профиль пользователя не содержит этой информации). <br><br>Если пользователь аноним, то обязано быть заполнено.<br>
  */
  @ActiveField()
  fio?: string


/**
  * promoCode
  * Промокод для расчёта скидки при оформлении (§7.3).<br>
  */
  @ActiveField()
  promoCode?: null | string


  /**
  * pointsToSpend
  * Сумма баллов к списанию при оформлении, в рублях.<br>  */
  @ActiveField()
  pointsToSpend?: number


  /**
  * attribution
  * Атрибуция источника заказа (идентификаторы веб-аналитики и метки визита).<br>Можно передавать при каждом изменении черновика — снапшот фиксируется<br>при выходе заказа из черновика<br>  */
  @ActiveField({
    factory: [OrderAttributionWrite, () => undefined]
  })
  attribution?: null | OrderAttributionWrite
}
